<template>
	<!-- has free offers AND there are 2+ monetization type offers (including the FREE one) -->
	<p v-if="freeOffers.length > 0 && availableMonetizationTypes.size >= 2">
		{{ $t('WEBAPP_SPIN_FREE_MORE_ALSO', { title, provider }) }}
	</p>

	<!-- has free offers: this case is covered already in SpinningText.vue:177 -->

	<!-- has no free or ads offers -->
	<p v-else-if="freeOffers.length === 0 && !availableMonetizationTypes.has(MonetizationType.Ads)">
		{{ $t('WEBAPP_SPIN_FREE_NONE', { title, provider }) }}
	</p>
</template>

<script setup lang="ts">
import { MonetizationType } from '@/@types/graphql-types';
import { useSpinningText } from '@/helpers/composables/useSpinningText';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed, toRefs } from 'vue';

const props = defineProps<{
	title: string;
	offers: TitleDetail['offers'];
	seasonNumber?: number | undefined;
	availableMonetizationTypes: Set<MonetizationType>;
}>();

const { getOfferTextBlock } = useSpinningText(toRefs(props));

// using getOfferTextBlock so we get the filtering, unique offers and joining
const provider = getOfferTextBlock(MonetizationType.Free, '', '');

const freeOffers = computed(() => props.offers.filter(offer => offer.monetizationType === MonetizationType.Free));
</script>

<style scoped lang="scss"></style>
